import { render, staticRenderFns } from "./questionLabel.vue?vue&type=template&id=b0e6499a&scoped=true&"
import script from "./questionLabel.vue?vue&type=script&lang=js&"
export * from "./questionLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e6499a",
  null
  
)

export default component.exports